import React from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import messages from './messages';
import ModalPortal from '../../../../../components/modal-portal';
import { SimpleModal } from '../../../../../components/simple-modal';

/**
 * Modal component for confirming tote deletion (both single and bulk)
 * @param {object} props
 * @param {() => void} props.onDelete
 * @param {() => void} props.onClose
 * @returns {React.ReactElement}
 */
const DeleteTotesModal = ({ onDelete, onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <SimpleModal
        actionButtonTheme={THEME_CONSTANTS.danger}
        actionMessage={messages.deleteTotesModalDeleteButton}
        headerMessage={messages.deleteTotesConfirmationModalTitle}
        onAction={onDelete}
        onClose={onClose}
        size='small'
      >
        <Text textType={TextType.Paragraph} value={messages.deleteTotesConfirmationMessage} />
        <Text textType={TextType.Paragraph} value={messages.deleteTotesConfirmationFooter} />
      </SimpleModal>
    </ModalPortal>
  );
};

export default DeleteTotesModal;
